import { PropsWithChildren } from 'react'
import { useFormContext } from 'react-hook-form'
import styles from './FormField.module.scss'
import clsx from 'clsx'

export interface UseFormFieldProps extends PropsWithChildren {
    name: string
    label: string
    disabled?: boolean
    warningText?: string
}

export const useFormField = <P extends UseFormFieldProps>(props: P) => {
    const { label, name, disabled, warningText, ...otherProps } = props
    const id = name

    return {
        formFieldProps: { id, name, label, disabled, warningText },
        childProps: { ...otherProps, id, name, disabled },
    }
}

interface Props extends UseFormFieldProps {
    id: string
}

export const FormField = ({ children, name, id, label, disabled, warningText }: Props) => {
    const form = useFormContext()
    const state = form.getFieldState(name, form.formState)

    return (
        <div className={styles.fieldContainer}>
            <label
                className={clsx(styles.fieldLabel, {
                    [styles.disabled]: disabled,
                })}
                htmlFor={id}
            >
                {label}
            </label>
            {children}
            {state.error && <p className={styles.errorText}>{state.error.message}</p>}
            {warningText && <p className={styles.errorText}>{warningText}</p>}
        </div>
    )
}
